import { render, staticRenderFns } from "./SmsConversationItem.vue?vue&type=template&id=1d706ade&"
import script from "./SmsConversationItem.vue?vue&type=script&lang=js&"
export * from "./SmsConversationItem.vue?vue&type=script&lang=js&"
import style0 from "./SmsConversationItem.vue?vue&type=style&index=0&id=1d706ade&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsConversationItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports